const strings = {
  note: 'Agora é só aguardar!',
  description: (name: string) =>
    `${name}, nosso time entrará em contato em breve.`,
  linkLabel: 'Enquanto isso, conheça o blog da Alice'
}

export { strings }
